import { provideIcons } from '@ng-icons/core';
import {
  lucideSettings,
  lucideChevronDown,
  lucideBadgeDollarSign,
  lucideSparkle,
  lucidePanelLeft,
  lucideLogOut,
  lucideVideo,
  lucideWallet,
  lucideGlobe,
  lucideFile,
  lucideFileText
} from '@ng-icons/lucide';

export const iconsProvider = provideIcons({
  lucideBadgeDollarSign,
  lucideSparkle,
  lucidePanelLeft,
  lucideLogOut,
  lucideVideo,
  lucideSettings,
  lucideWallet,
  lucideChevronDown,
  lucideGlobe,
  lucideFileText
});
